export default __webpack_public_path__ + "static/media/challenges.d5fe0341.svg";